import { EventDispatcher } from "three";
import { ViewType } from "../Models/AppModel.js";
import { FlipType, FlipTypeGarage } from '../States/State.js';
/**
 * Manages the communications between three.js and angular part.
 */
export class BridgeBase extends EventDispatcher {
    constructor(context, model) {
        super();
        this._context = context;
        this._model = model;
    }
    /**
     * Dispatch an event from angular part to three.js part
     */
    mapEvent(type, args) {
        switch (type) {
            case "setViewAP":
                return this._context.handle("setView", ViewType.AP);
            case "setViewLT":
                return this._context.handle("setView", ViewType.LT);
            case "setViewMultiple":
                return this._context.handle("setViewMultiple", null);
            case "zoomIn":
                return this._context.handle("zoomIn", null);
            case "zoomOut":
                return this._context.handle("zoomOut", null);
            case "fitToView":
                return this._context.handle("fitToView", null);
            case "setBrightness":
                return this._context.handle("setBrightness", args);
            case "setContrast":
                return this._context.handle("setContrast", args);
            case "setVisibility_mechanicalAxis_anatomical":
                return this._context.handle("setVisibility", { key: "mechanicalAxis_anatomical", value: args });
            case "setVisibility_mechanicalAxis_mechanical":
                return this._context.handle("setVisibility", { key: "mechanicalAxis_mechanical", value: args });
            case "setVisibility_mechanicalAxis_weightBearing":
                return this._context.handle("setVisibility", { key: "mechanicalAxis_weightBearing", value: args });
            case "setVisibility_anatomicalAxis":
                return this._context.handle("setVisibility", { key: "anatomicalAxis", value: args });
            case "setVisibility_contralateral_all":
                return this._context.handle("setVisibility", { key: "contralateral_all", value: args });
            case "setVisibility_lines":
                return this._context.handle("setVisibility", { key: "lines", value: args });
            case "setVisibility_goniometers":
                return this._context.handle("setVisibility", { key: "goniometers", value: args });
            case "setVisibility_labels":
                return this._context.handle("setVisibility", { key: "labels", value: args });
            case "stopRegistering":
                return this._context.handle("stopRegistering", null);
            case "resetRegistering":
                return this._context.handle("resetRegistering", null);
            case "completeRegistering":
                return this._context.handle("completeRegistering", -1); // TODO check
            case "addLine":
                return this._context.handle("addLine", null);
            case "addGoniometer":
                return this._context.handle("addGoniometer", null);
            case "resetLabelsPosition":
                return this._context.handle("resetLabelsPosition", null);
            case "deleteMeasurementTool":
                return this._context.handle("deleteMeasurementTool", null);
            case "startCrop":
                return this._context.handle("startCrop", this._model.activeView);
            case "startRotate":
                return this._context.handle("startRotate", this._model.activeView);
            case "confirmCrop":
                return this._context.handle("confirmCrop", null);
            case "confirmRotate":
                return this._context.handle("confirmRotate", null);
            case "flipHorizontal":
                return this._context.handle("setFlip", { viewType: this._model.activeView, flipType: FlipType.horizontal });
            case "flipVertical":
                return this._context.handle("setFlip", { viewType: this._model.activeView, flipType: FlipType.vertical });
            case "flipHorizontalGarage":
                return this._context.handle("setFlipGarage", { viewType: this._model.activeView, flipType: FlipTypeGarage.horizontal });
            case "flipVerticalGarage":
                return this._context.handle("setFlipGarage", { viewType: this._model.activeView, flipType: FlipTypeGarage.vertical });
            case "flipBothGarage":
                return this._context.handle("setFlipGarage", { viewType: this._model.activeView, flipType: FlipTypeGarage.both });
            case "undo":
                return this._context.handle("undo", null);
            case "redo":
                return this._context.handle("redo", null);
            case "startTrackingPlane":
                return this._context.handle("startTrackingPlane", null);
            case "detectChangesPlane":
                return this._context.handle("detectChangesPlane", null);
            default:
                return console.error("BridgeActions not recognized:", type, "not exists.");
        }
    }
}
//# sourceMappingURL=Bridge.js.map